import React from 'react';

import { Box, Button, FormikField, H1, Input, Select } from '@betterment/samba-react';
import { FormikValidateAfterSubmit } from '@betterment/shared-components';
import { Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { FlowLayout } from './FlowLayout';

import { US_STATES } from '../Shared/constants';

// TODO: Replace with data from GraphQL query
const PREFILLED_ADDRESS = {
  addressLine1: '450 West 33rd Street',
  addressLine2: '',
  city: 'New York',
  state: 'NY',
  zip: '10001',
};

type FormValues = typeof PREFILLED_ADDRESS;

const ValidationSchema = Yup.object().shape({
  addressLine1: Yup.string().required('Please enter an address'),
  addressLine2: Yup.string(),
  city: Yup.string().required('Please enter a city'),
  state: Yup.string().required('Please select a state'),
  zip: Yup.string()
    .required('Please enter a zip code')
    .matches(/^\d{5}$/, 'Please enter a valid zip code'),
});

const CheckAddress: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = (_values: FormValues) => {
    void navigate('../confirmation');
  };

  return (
    <FlowLayout>
      <H1>Where do you want your check to go?</H1>
      <FormikValidateAfterSubmit
        initialValues={PREFILLED_ADDRESS}
        validationSchema={ValidationSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Box css={{ pb: 'space.300' }}>
              <FormikField name="addressLine1">
                <FormikField.Label>Address line 1</FormikField.Label>
                <FormikField.Control>
                  <Input type="text" inputMode="text" />
                </FormikField.Control>
                <FormikField.ErrorMessage />
              </FormikField>
            </Box>
            <Box css={{ pb: 'space.300' }}>
              <FormikField name="addressLine2">
                <FormikField.Label>Address line 2</FormikField.Label>
                <FormikField.Control>
                  <Input type="text" inputMode="text" />
                </FormikField.Control>
                <FormikField.ErrorMessage />
              </FormikField>
            </Box>
            <Box css={{ pb: 'space.300' }}>
              <FormikField name="city">
                <FormikField.Label>City</FormikField.Label>
                <FormikField.Control>
                  <Input type="text" inputMode="text" />
                </FormikField.Control>
                <FormikField.ErrorMessage />
              </FormikField>
            </Box>
            <Box css={{ pb: 'space.300' }}>
              <FormikField name="state">
                <FormikField.Label>State</FormikField.Label>
                <FormikField.Control>
                  <Select>
                    <Select.Trigger aria-label="State">
                      <Select.Value placeholder="Choose one" />
                    </Select.Trigger>
                    <Select.Content>
                      {Object.keys(US_STATES)
                        .sort()
                        .map(abbr => (
                          <Select.Item key={abbr} value={abbr}>
                            {abbr}
                          </Select.Item>
                        ))}
                    </Select.Content>
                  </Select>
                </FormikField.Control>
                <FormikField.ErrorMessage />
              </FormikField>
            </Box>
            <Box css={{ pb: 'space.300' }}>
              <FormikField name="zip">
                <FormikField.Label>Zip code</FormikField.Label>
                <FormikField.Control>
                  <Input type="text" inputMode="numeric" maxLength={5} />
                </FormikField.Control>
                <FormikField.ErrorMessage />
              </FormikField>
            </Box>
            <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
              Continue
            </Button>
          </Form>
        )}
      </FormikValidateAfterSubmit>
    </FlowLayout>
  );
};

export default CheckAddress;
